/* eslint-disable */
import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
// import { Container } from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <Stack spacing={1}>
      {/* For variant="text", adjust the height via font-size */}
      <Skeleton variant="rounded" width="100%" height={30} />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
      <Skeleton
        variant="rounded"
        width="100%"
        height={22}
        style={{ marginTop: 4 }}
      />
    </Stack>
  );
};

export default SkeletonLoading;
